// declare __myinsenv namespace in window
declare global {
  interface Window {
    __myinsenv: any // eslint-disable-line
  }
}

const APP_ENV: string = window.__myinsenv?.APP_ENV || process.env.APP_ENV
const APP_BRAND: string = window.__myinsenv?.APP_BRAND || process.env.APP_BRAND
const APP_OFFICE_PHONE: string =
  window.__myinsenv?.OFFICE_PHONE || process.env.OFFICE_PHONE
const APP_OFFICE_PHONE_URL: string =
  window.__myinsenv?.OFFICE_PHONE_URL || process.env.OFFICE_PHONE_URL
const FRONT_PAGE_URL: string =
  window.__myinsenv?.FRONT_PAGE_URL || process.env.FRONT_PAGE_URL
const LOGO_TEXT: string = window.__myinsenv?.LOGO_TEXT || process.env.LOGO_TEXT
const BACKEND_URL: string =
  window.__myinsenv?.BACKEND_URL || process.env.BACKEND_URL

export type EnvType = 'local' | 'test' | 'qa' | 'prod'
export type BrandType = 'POP' | 'SP'

const getEnv = () => {
  const env: EnvType = APP_ENV as EnvType
  const brand: BrandType = APP_BRAND as BrandType
  const officePhone: string = APP_OFFICE_PHONE
  const officePhoneUrl: string = APP_OFFICE_PHONE_URL
  const frontPageUrl: string = FRONT_PAGE_URL
  const logoText: string = LOGO_TEXT
  const backendUrl: string = BACKEND_URL

  return {
    env,
    brand,
    officePhone,
    officePhoneUrl,
    frontPageUrl,
    logoText,
    backendUrl,
  }
}

export default getEnv
